/**
 * @fileoverview Single trust-signal pill.
 * @description Renders one icon+label badge (e.g. "256-bit Encrypted"). See TrustBadgeList for
 * the row of badges shown together on the login card.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

interface TrustBadgeProps {
  icon: string
  label: string
}

/**
 * @component
 * @param {TrustBadgeProps} props - The badge's icon and label.
 * @param {string} props.icon - URL of the badge's icon (imported SVG asset).
 * @param {string} props.label - The badge's text, e.g. "FDIC Insured".
 */
function TrustBadge({ icon, label }: TrustBadgeProps) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-primary/[0.14] bg-primary/5 px-3 py-[5px] text-[12px] font-medium text-slate">
      <img src={icon} alt="" className="h-[13px] w-[13px]" />
      {label}
    </span>
  )
}

export default TrustBadge
